<div class="search-form">
  <div
    class="search_top_body_container_advance"
    *ngIf="selectedSearchOption === 1"
  >
    <form [formGroup]="filterForm_advanced" (ngSubmit)="search()">
      <ng-container formArrayName="advfilters">
        <!-- Dynamic Search Criteria Rows -->
        <div
          *ngFor="let advfilterForm of advfilters?.controls; let i = index"
          class="criteria-row mb-4"
          [formGroupName]="i"
        >
          <!-- Operator Selection -->
          <div class="field-group operator" *ngIf="i > 0">
            <h1 class="field-label">Operator</h1>
            <div class="operator-options">
              <label for="and_operator_advance_{{ i }}">
                <input
                  type="radio"
                  id="and_operator_advance_{{ i }}"
                  formControlName="ddloprator"
                  value="AND"
                />
                AND </label
              >&nbsp;&nbsp;
              <label for="or_operator_advance_{{ i }}">
                <input
                  type="radio"
                  id="or_operator_advance_{{ i }}"
                  formControlName="ddloprator"
                  value="OR"
                />
                OR
              </label>
            </div>
          </div>

          <!-- Text Search Field Selection -->
          <div class="fields">
            <div class="field-group text-search-field">
              <h1 class="field-label">Search Field</h1>
              <p-dropdown
                formControlName="ddlfieldnameadv"
                [options]="dropdownItems"
                optionLabel="truncatedLabel"
                optionValue="field"
                placeholder="Select Text Search Field"
                filter="true"
                [filterBy]="'truncatedLabel'"
                class="select-field w-full"
              >
              </p-dropdown>
            </div>
          </div>

          <!-- Keyword Input -->
          <div class="field-group keywords">
            <h1 class="field-label">Your Keywords</h1>
            <input
              type="text"
              placeholder="Enter Your Keywords"
              formControlName="txtfiltervalue"
              class="keyword-input"
              *ngIf="
                this.getFieldType(
                  this.filterForm_advanced.value.advfilters[i].ddlfieldnameadv
                ) !== 'date'
              "
            />
            <p-calendar
              formControlName="txtfiltervalue"
              placeholder="Enter the date or date range format should be mm/dd/yyyy"
              selectionMode="range"
              class="adv-calender"
              *ngIf="
                this.getFieldType(
                  this.filterForm_advanced.value.advfilters[i].ddlfieldnameadv
                ) === 'date'
              "
            >
            </p-calendar>
          </div>

          <!-- Add/Remove Buttons -->
          <div class="button-group">
            <button type="button" (click)="deleteFilter(i)" class="remove-btn">
              -
            </button>
            <button type="button" (click)="addFilter()" class="add-btn">
              +
            </button>
          </div>
        </div>
      </ng-container>

      <!-- Buttons Section -->
      <div class="flex flex-wrap-reverse justify-between gap-4 py-4 mt-2">
        <button
          type="button"
          class="px-6 py-2 bg-[#FFCD04] rounded-lg font-semibold text-[#303027] text-[16px] leading-[20px] flex items-center justify-between cursor-pointer w-auto min-w-[350px] md:min-w-[400px] lg:min-w-[450px]"
          (click)="showVideoModal()"
        >
          <div>Explore More With Tutorials</div>
          <img
            src="../../../assets/icons/Video.png"
            alt="YouTube"
            class="w-6 h-6"
          />
        </button>

        <p-dialog
          header="Tutorial Video"
          [(visible)]="displayVideoModal"
          [modal]="true"
          [responsive]="true"
          [style]="{ width: '80vw' }"
        >
          <iframe
            *ngIf="videoUrl"
            [src]="videoUrl"
            width="100%"
            height="400"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </p-dialog>
        <div class="mt-3 flex justify-end gap-4 w-full lg:w-[30%] md:w-[45%]">
          <button
            type="submit"
            class="flex-grow px-4 py-3 text-[15px] leading-[18.29px] font-semibold rounded-full transition-all duration-300"
            style="
              background: linear-gradient(145.5deg, #388e3c, #0f4363 99.58%);
              color: rgb(255, 237, 141);
            "
            onmouseover="this.style.background='linear-gradient(145.5deg, #388e3c, #388e3c 99.58%)'; this.style.color='white';"
            onmouseout="this.style.background='linear-gradient(145.5deg, #388e3c, #0f4363 99.58%)'; this.style.color='rgb(255, 237, 141)';"
          >
            Search
          </button>
          <button
            class="flex-grow border-2 px-4 py-3 text-[15px] leading-[18px] border-[#388e3c] font-semibold text-[#388e3c] rounded-full"
            type="button"
            (click)="resetallform()"
          >
            Reset
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
<!-- Alert Dialogs if user not have privilege -->
<!-- Search Privilege dialog -->
<p-dialog
  header="Search Privilege"
  [(visible)]="is_show_Search_Priv_popup"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25vw', padding: '0px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You don't have permission to Search, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--  Daily Search Exceed dialog -->
<p-dialog
  header="Daily Search Exceed"
  [(visible)]="is_show_Daily_Search_Exceed_popup"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25vw', padding: '0px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You have exceeded the daily search limit, please contact the support team
      at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--  Total Search Exceed  dialog -->
<p-dialog
  header="Total Search Exceed"
  [(visible)]="is_show_Total_Search_Exceed_popup"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25vw', padding: '0px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      Your search count is exhausted, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Download  Privilege dialog -->
<p-dialog
  header="Download Privilege"
  [(visible)]="is_show_Download_Priv_popup"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25vw', padding: '0px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You don't permission to download, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--  Daily Download Exceed dialog -->
<p-dialog
  header="Daily Download Exceed"
  [(visible)]="is_show_Daily_Download_Exceed_popup"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25vw', padding: '0px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You have exceeded the daily download limit, please contact the support
      team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--  Total Downalod Exceed  dialog -->
<p-dialog
  header="Total Download Exceed "
  [(visible)]="is_show_Total_Download_Exceed_popup"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25vw', padding: '0px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      Your download count is exhausted, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>
